import React from 'react';
import Axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class LeagueAdminAddSeasonModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seasonName: '',
      disableSubmit: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSaveSeason = this.handleSaveSeason.bind(this);
  }

  handleInputChange(e) {
    this.setState({ seasonName: e.target.value });
  }

  handleSaveSeason(e) {
    e.preventDefault();

    if (!this.state.seasonName.trim()) {
      alert("Veuillez entrer un nom de saison.");
      return;
    }

    this.setState({ disableSubmit: true });

    Axios.post('/api/seasons/', {
      seasonName: this.state.seasonName.trim(),
      leagueObjId: this.props.league._id
    })
    .then(() => {
      this.props.reloadLeagues();
      this.props.onClose();
    })
    .catch((error) => {
      console.error(error);
      this.props.onClose();
    });
  }

  render() {
    return (
      <Modal isOpen={this.props.showModal} size="sm" className={this.props.className}>
        <form className="form-horizontal" onSubmit={this.handleSaveSeason}>
          <ModalHeader>
            Ajouter une saison
          </ModalHeader>

          <ModalBody>
            <div className="form-group">
              <label>Nom de la saison</label>
              <input
                type="text"
                className="form-control"
                placeholder="ex: AH-2024"
                value={this.state.seasonName}
                onChange={this.handleInputChange}
              />
            </div>
          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary btn-sm stdCommandButton2"
              onClick={this.props.onClose}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-sm stdCommandButton2"
              disabled={this.state.disableSubmit}
            >
              Ajouter
            </button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

export default LeagueAdminAddSeasonModal;
